@use "~theme/breakpoints";

$lockup-height: 44px;
$partner-max-width: 165.59px;
$myeyedr-width: 168.99px;
$column-gap: 16px;

.link {
  display: block;
  width: fit-content;
  max-width: calc(100vw - (2 * var(--mobile-gutter)));
  color: var(--white);
  text-decoration: none;
}

.lockup {
  display: flex;
  align-items: center;
  gap: $column-gap;
  width: fit-content;
  max-width: 100%;
  height: $lockup-height;
}

.cobrandedLogoContainer,
.vintageNameContainer {
  box-sizing: border-box;
  display: flex;
  align-items: center;
  width: 100%;
  overflow: hidden;
}

.cobrandedLogoContainer {
  flex: 0 1 auto;
  justify-content: center;
  width: fit-content;
  max-width: $partner-max-width;
  height: 40px;
  padding: 6px 12px;
  background-color: var(--white);
  border-radius: 8px;
}

.cobrandedLogo {
  display: block;
  width: auto;
  max-width: calc($partner-max-width - 24px);
  height: 100%;
  object-fit: contain;
}

.vintageNameContainer {
  flex: 0 1 auto;
  justify-content: center;
  width: fit-content;
  max-width: 168px;
  height: 100%;
  overflow: visible;

  @include breakpoints.desktop {
    height: 51px;
  }
}

.vintageName {
  display: block;
  width: max-content;
  max-width: 168px;
  max-height: 45px;
  overflow: hidden;
  color: var(--white);
  font-family: Montserrat, sans-serif;
  font-size: 12px;
  font-style: normal;
  font-weight: 700;
  line-height: 125%;
  letter-spacing: 0;
  text-align: left;
  overflow-wrap: anywhere;

  @include breakpoints.desktop {
    max-height: 53px;
    font-size: 14px;
  }
}

.divider {
  flex: 0 0 auto;
  width: 0;
  height: 40px;
  border-left: 1px solid var(--white);
}

.myEyeDrContainer {
  display: flex;
  flex: 0 1 $myeyedr-width;
  flex-direction: column;
  gap: 4px;
  justify-content: center;
  width: $myeyedr-width;
  min-width: 0;
  height: 100%;
}

.tagline {
  display: block;
  height: 16px;
  color: var(--white);
  font-family: Montserrat, sans-serif;
  font-size: 12px;
  font-weight: 600;
  line-height: 130%;
  white-space: nowrap;
}

.myEyeDrLogo {
  display: block;
  width: 100%;
  height: 24px;
  object-fit: contain;
}